import { CSSProperties } from 'react';

type FrameSectionProps = {
    title: string;
    style?: CSSProperties;
};

function FrameSection({
    title,
    style = {},
}: FrameSectionProps) {
    return (
        <div
            style={{
                textAlign: 'center',
                fontWeight: 600,
                fontSize: 16,
                textTransform: 'uppercase',
                ...style,
            }}
        >
            {title}
            <hr
                style={{
                    borderColor: '#000000',
                    borderWidth: 2,
                    opacity: 1,
                }} />
        </div>
    );
}

export default FrameSection;
